import InterviewContainer from '../InterviewContainer';
import {
  IDiagnosisOfConcernInterviewProps,
  IDynamicInterviewProps,
} from 'src/packages/polaris/types/interviews';

const DynamicInterviewContainer = ({
  conditionName,
  formLocation,
  isEmbedded = false,
  onQuestionDisplay,
  onQuestionSubmit,
  polarisProps,
  slug,
}:
  | Pick<
      IDiagnosisOfConcernInterviewProps,
      | 'conditionName'
      | 'dxocs'
      | 'interviewType'
      | 'isEmbedded'
      | 'formLocation'
      | 'onQuestionDisplay'
      | 'onQuestionSubmit'
      | 'polarisProps'
      | 'slug'
    >
  | Pick<
      IDynamicInterviewProps,
      | 'conditionName'
      | 'complaints'
      | 'interviewType'
      | 'isEmbedded'
      | 'formLocation'
      | 'onQuestionDisplay'
      | 'onQuestionSubmit'
      | 'polarisProps'
      | 'slug'
    >) => {
  return (
    <InterviewContainer
      conditionName={conditionName}
      formLocation={formLocation}
      isEmbedded={isEmbedded}
      onQuestionDisplay={onQuestionDisplay}
      onQuestionSubmit={onQuestionSubmit}
      polarisProps={polarisProps}
      slug={slug}
    />
  );
};

export default DynamicInterviewContainer;
